import {createContext, useContext, useEffect, useState} from "react";
import {collection, getDocs} from "firebase/firestore/lite";
import {db} from "../firebase"
const TypeContext = createContext();


export const TypeContextProvider = ({children}) =>
{
	const [getName, setName] = useState()


	async function getTypes(db)
	{
		const typesCol = collection(db, 'types');
		const typeSnapshot = await getDocs(typesCol);
		const typeList = typeSnapshot.docs.map(doc => doc.data().name);
        setName(typeList)
		return getName;
	}


    useEffect(() => {
      getTypes(db);
    }, [])

	return (
		<TypeContext.Provider value={[{getName}]}>
			{children}
		</TypeContext.Provider>
	)
}

export const UseTypes = () => {
	return useContext(TypeContext)
}
//
// export const UserTypes = () => {
// 	return useContext(TypeContext)
// }

